import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorText } from "@/lib/api";
import { useSite } from "@/context/SiteContext";

export const field = "w-full rounded-sm border border-line bg-surface px-3 py-2.5 text-sm outline-none focus:border-brand";

export const useAdminSettings = () => {
  const [settings, setSettings] = useState(null);
  const { reload } = useSite() || {};
  useEffect(() => { api.get("/admin/settings").then((r) => setSettings(r.data)).catch((e) => toast.error(errorText(e))); }, []);
  const save = useCallback(async (patch) => {
    try {
      const { data } = await api.put("/admin/settings", patch);
      setSettings(data);
      reload?.();
      toast.success("Cambios guardados");
      return data;
    } catch (e) { toast.error(errorText(e)); }
  }, [reload]);
  return { settings, setSettings, save };
};

export const Field = ({ label, id, ...p }) => (
  <label className="block text-xs uppercase tracking-wider text-mute">{label}
    <input className={`${field} mt-1 normal-case tracking-normal`} data-testid={id} {...p} />
  </label>
);

export const Panel = ({ title, children, action }) => (
  <section className="card-dark p-6">
    <div className="mb-5 flex items-center justify-between gap-3"><h2 className="text-2xl font-bold uppercase">{title}</h2>{action}</div>
    {children}
  </section>
);
